<div class="flex flex-column justify-content-left font w-full">
  <div class="block">
    <label>Restrição Financeira GRAVAME: </label>
    <span [ngClass]="this.restrictions?.financialRestriction == true ? 'red' : 'c-success'">{{
      this.restrictions?.financialRestriction ? 'Sim' : 'Não' }}</span>
  </div>
  <div class="block">
    <label>Arrendatário: </label>
    <span [ngClass]="this.restrictions?.tenantRestriction == true ? 'red' : 'c-success'">{{
      this.restrictions?.tenantRestriction ? 'Sim' : 'Não' }}</span>
  </div>
  <div class="block">
    <label>Restrições Administrativas: </label>
    <span [ngClass]="this.restrictions?.administrativeRestriction == true ? 'red' : 'c-success'">{{
      this.restrictions?.administrativeRestriction ? 'Sim' : 'Não' }}</span>
  </div>
  <div class="block">
    <label>Restrição Judicial: </label>
    <span [ngClass]="this.restrictions?.judicialRestriction == true ? 'red' : 'c-success'">{{
      this.restrictions?.judicialRestriction ? 'Sim' : 'Não' }}</span>
  </div>
  <div class="block">
    <label>Restrição Tributária: </label>
    <span [ngClass]="this.restrictions?.taxRestriction == true ? 'red' : 'c-success'">{{
      this.restrictions?.taxRestriction ? 'Sim' : 'Não' }}</span>
  </div>
  <div class="block">
    <label>Bloqueio Judicial: </label>
    <span [ngClass]="this.restrictions?.judicialBlock == true ? 'red' : 'c-success'">{{
      this.restrictions?.judicialBlock ? 'Sim' : 'Não' }}</span>
  </div>
  <div class="block">
    <label>Roubo ou Furto: </label>
    <span [ngClass]="this.restrictions?.theft == true ? 'red' : 'c-success'">{{ this.restrictions?.theft ? 'Sim' :
      'Não' }}</span>
  </div>

  <div class="flex justify-content-center align-items-center text-center mt-3">
    <oc-button (click)="onClose()" class="btn-primary octa" [label]="'Voltar'"></oc-button>
  </div>
</div>